class Jkea_SliderFixes {
  constructor(options) {
    Object.assign(this, options)
    this.visibilityThreshold = 0.75 // 75% visibility threshold
    this.initmarker = "jkeafix-initialized"
    this.sliderSelector = ".jkea-slider > .slideshow"
    this.init()
  }
  init() {
    this.checkForSlickSliderInitialization()
  }

  checkForSlickSliderInitialization() {
    const jkeaSliders = document.querySelectorAll(this.sliderSelector)
    if (!jkeaSliders.length) return
    jkeaSliders.forEach((jkeaSlider) => {
      if (!jkeaSlider.classList.contains(this.initmarker) && jkeaSlider.classList.contains("slick-initialized")) {
        jkeaSlider.classList.add(this.initmarker)
        this.reversePositions(jkeaSlider)
      } else if (!jkeaSlider.classList.contains(this.initmarker)) {
        this.observeJkeaSliderSetup(jkeaSlider)
      }
    })
  }

  observeJkeaSliderSetup(jkeaSlider) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && jkeaSlider.classList.contains("slick-initialized")) {
          observer.disconnect()
          jkeaSlider.classList.add(this.initmarker)
          this.reversePositions(jkeaSlider) // reverse order in DOM
          this.switchFocusOnEnterInit(jkeaSlider)
        }
      })
    })
    observer.observe(jkeaSlider, { attributes: true, attributeFilter: ["class"] })
  }

  reversePositions(slider) {
    // Select the .slick-list and .slick-dots elements
    const slickList = slider.querySelector(".slick-list")
    const slickDots = slider.querySelector(".slick-dots")
    if (!slickList || !slickDots) return
    // Swap the positions of .slick-list and .slick-dots
    slider.insertBefore(slickDots, slickList)
    slickDots.style.setProperty("position", "relative", "important")
  }
  switchFocusOnEnterInit(slider) {
    const navButtons = slider.querySelectorAll(`.slick-dots button`)
    if (navButtons.length > 12) {
      slider.querySelector(".slick-dots").style.flexWrap = "wrap"
    }
    navButtons.forEach((button) => {
      button.slider = slider // Store the slider as a property of the button

      button.addEventListener("keydown", this.handleKeydownOnButton.bind(this))
      button.addEventListener("blur", this.handleBlurOnButton.bind(this, button))
    })
  }

  handleKeydownOnButton(event) {
    const button = event.target
    const slider = button.slider // Retrieve the slider from the button

    if (event.key === "Enter") {
      const describedByLabel = button.getAttribute("aria-describedby")
      const describedByElement = slider.querySelector(`[data-tablabel="${describedByLabel}"]`)

      if (describedByElement) {
        button.originalTabindex = describedByElement.getAttribute("tabindex")
        const slideUnit = describedByElement.closest(".slick-slide")
        describedByElement.setAttribute("tabindex", "0") // Make the element focusable
        describedByElement.focus()
        slideUnit?.classList.add("focused-slider")
        describedByElement.addEventListener("keydown", this.handleKeydownOnDescribedBy.bind(this, button))
        describedByElement?.addEventListener("blur", {
          handleEvent: (event) => {
            describedByElement.removeEventListener("keydown", this.handleKeydownOnDescribedBy)
            describedByElement.closest(".slick-slide")?.classList.remove("focused-slider")
            // this.handleBlurOnButton(button)
          },
        })
      }
    }
  }

  handleKeydownOnDescribedBy(button, event) {
    if (event.key === "Escape") {
      event.target.removeEventListener("keydown", this.handleKeydownOnDescribedBy)
      button.focus()
      event.target.setAttribute("tabindex", button.originalTabindex || "")
    }
  }

  handleBlurOnButton(button) {
    const describedById = button.getAttribute("aria-describedby")
    const describedByElement = document.getElementById(describedById)
    if (describedByElement) {
      describedByElement.removeEventListener("keydown", this.handleKeydownOnDescribedBy)
      describedByElement.closest(".slick-slide")?.classList.remove("focused-slider")
    }
  }
}
export { Jkea_SliderFixes }
